import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledFilterOnlineBuyingContainer = styled.div<any>`
  align-items: center;
  display: flex;
  gap: 2px;
  justify-content: right;
  width: 100%;

  span {
    margin: 0;
    text-align: right;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: auto;
  }
`;
